import { useState } from "react";
import { useRouter } from "next/router";
import { CompatibilityResultContainer } from "./style";
import { mapSign } from "@/helpers/getCompatibilityBetweenSigns";
import { getCompatibilityBetweenSigns } from "@/helpers/getCompatibilityBetweenSigns";
import { signsDates } from "@/helpers/getCompatibilityBetweenSigns";
import SocialNetworking from "@/shared/SocialNetworking";
import ContentIcon from "@/shared/ContentIcon";

const CompatibilityResult = (props) => {
  const { compatibilitySigns } = props;
  const router = useRouter();
  console.log("holaaa3", props)
  const firstSign = compatibilitySigns[0];
  const secondSign = compatibilitySigns[1];


  return (
    <CompatibilityResultContainer>
      <div className="selected-signs-container">
        <div className="sign-container">
          <div className={`circle red-circle`}>
            <img
              width="106px"
              height="106px"
              loading="lazy"
              alt={firstSign}
              src={`/img/westernastrology/${firstSign}.svg`}
            />
          </div>
          <span className="sign-name">{mapSign[firstSign]}</span>
          <span className="sign-date">{signsDates[firstSign]}</span>
        </div>

        <span className="plus">
          <ContentIcon width="16px" height="16px" nameIcon="plus" fill="#000" />
        </span>

        <div className="sign-container">
          <div className={`circle red-circle`}>
            <img
              width="106px"
              height="106px"
              loading="lazy"
              alt={secondSign}
              src={`/img/westernastrology/${secondSign}.svg`}
            />
          </div>
          <span className="sign-name">{mapSign[secondSign]}</span>
          <span className="sign-date">{signsDates[secondSign]}</span>
        </div>
      </div>

      <div className="text-result-compatibility">
        <p>{getCompatibilityBetweenSigns[firstSign][secondSign]}</p>
        <p className="text-credit">
          Asesoró Beatriz Leveratto, astróloga, tarotista y directora de la
          escuela Consideral de astrología y tarot.
        </p>
      </div>

      <div className="text-result-share">
        {<SocialNetworking
          url={router.asPath}
          title={firstSign + " y " + secondSign}
          socialNetworkingSelect={["facebook", "twitter", "whatsapp", "share"]}
  />}
      </div>
    </CompatibilityResultContainer>
  );
};

export default CompatibilityResult;
